import { render, staticRenderFns } from "./Subtitle.vue?vue&type=template&id=021aaadc&scoped=true&"
import script from "./Subtitle.vue?vue&type=script&lang=js&"
export * from "./Subtitle.vue?vue&type=script&lang=js&"
import style0 from "./Subtitle.vue?vue&type=style&index=0&id=021aaadc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021aaadc",
  null
  
)

export default component.exports